/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tab/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'



/** @type {import('Simple/types.js').View} */
export default function Tab({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/Payor/Content/Tabs/Tab"
  
}) {
let tabPersonValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'person',
format: fromFormat.personName,
})
let selectedPayorIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'payor_id',
})
let tabIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'id',
})
let aggregateData = fromAggregate.equals(selectedPayorIdValueData, tabIdValueData)
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 color={dtColorsBlack}
 paddingRight={dtSpaceXs}
 size="normal"
 data="tab.person"
 format="/Data/format.js personName"
 text={tabPersonValueData}
 onClick={onClick}
 data="selected.payor_id"
 data="tab.id"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
/>
{children}
</React.Fragment>)
}